import axios from "axios";
import React, { useState, useEffect } from "react";
import {databaseUrl} from "../../server/server";
//material ui
import Grid from '@mui/material/Grid';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';

import { useLocation, useNavigate } from "react-router-dom";


let access = localStorage.getItem("accesstoken");

function not(a, b) {
  return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
  return a.filter((value) => b.indexOf(value) !== -1);
}

const Orderboards_select_man = () => {

  
const location = useLocation(); // 추가된 부분
const datasss = location.state?.data; // 추가된 부분
const navigate = useNavigate();


  //const params = new URLSearchParams(window.location.search);
//let visitday = params.get("visitday");
const selectLeft = [];
const selectRight = [];
const [visitdate, setVisitDate] = useState(datasss);
const [endDate, setEndDate] = useState(datasss);
const [visitor, setVisitor] = useState([]);
const [checked, setChecked] = useState([]);
const [left, setLeft] = useState([]);
const [right, setRight] = useState([]);

    useEffect(() => {
        axios.get(`${databaseUrl}/orderboard/visitor?visitday=${datasss}`,{
            headers: {Authorization:`Bearer ${access}`},
        }
        ).then((response)=>{
            for(let i = 0; i < response.data.visitor.length; i++){
                if(!selectRight.includes(response.data.visitor[i])){
                    selectRight.push(response.data.visitor[i]);
                }
            }
            setRight([...selectRight]);
            for(let i = 0; i < response.data.notvisitor.length; i++){
                if(!selectLeft.includes(response.data.notvisitor[i])){
                    selectLeft.push(response.data.notvisitor[i]);
               }
            }
            setLeft([...selectLeft]);
        })
    }, [])

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);
  const handleToggle = (value) => () => {
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);
  };

  const handleAllRight = () => {
    setRight(right.concat(left));
    setLeft([]);
  };

  const handleCheckedRight = () => {
    setRight(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
  };
  const handleAllLeft = () => {
    setLeft(left.concat(right));
    setRight([]);
  };
  const handleSubmit = (event) => {
    event.preventDefault();
    axios.get(`${databaseUrl}/orderboard/checkvisitor?day=${datasss}&v=${right}&nv=${left}&enddate=${endDate}`,{
        headers: {Authorization:`Bearer ${access}`},
    }
    ).then((response)=>{
        console.log(response.data);
        if(response.data === 'query OK!'){
          navigate( '/Orderboards', { state: {visitday:datasss} } )
        }else{
            alert('error');
        }
    })
  }
  const clickOrderday = (event) => {
    setEndDate(event.target.value);

    console.log(endDate);

  }
  const customList = (items) => (
    <Paper sx={{ width: 150, height: 450, overflow: 'auto' }}>
      <List dense component="div" role="list">
        {items.map((value) => {
          const labelId = `transfer-list-item-${value}-label`;
          return (
            <ListItemButton
              key={value}
              role="listitem"
              onClick={handleToggle(value)}
            >
              <ListItemIcon>
                <Checkbox
                  checked={checked.indexOf(value) !== -1}
                  tabIndex={-1}
                  disableRipple
                  inputProps={{
                    'aria-labelledby': labelId,
                  }}
                />
              </ListItemIcon>
              <ListItemText id={labelId} primary={`${value}`} />
            </ListItemButton>
          );
        })}
      </List>
    </Paper>
  );
  return (
    <div className="select_visitor">
    <div><h1> Select Visitor {visitdate} ~ <input type="date" className="outputdate" value={endDate} onChange={clickOrderday} /></h1></div>
    <form onSubmit={handleSubmit}>
        <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item>
            <div><h1>대기인원</h1></div>
            {customList(left)}
        </Grid>
        <Grid item>
            <Grid container direction="column" alignItems="center">
            <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllRight}
                disabled={left.length === 0}
                aria-label="move all right"
            >
                ≫
            </Button>
            <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedRight}
                disabled={leftChecked.length === 0}
                aria-label="move selected right"
            >
                &gt;
            </Button>
            <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleCheckedLeft}
                disabled={rightChecked.length === 0}
                aria-label="move selected left"
            >
                &lt;
            </Button>
            <Button
                sx={{ my: 0.5 }}
                variant="outlined"
                size="small"
                onClick={handleAllLeft}
                disabled={right.length === 0}
                aria-label="move all left"
            >
                ≪
            </Button>
            </Grid>
        </Grid>
        <Grid item>
            <div><h1>출동인원</h1></div>
            {customList(right)}
            </Grid>
        </Grid>
        <input type="submit" value="Submit" className="selectman_submit" />
      </form>
    </div>
  );
}
export default Orderboards_select_man;